/*
 * Class for executing Widget Change
 * @module
 */
var _ = require('optimizely-client-fn');

var deferred = require('core/utils/deferred');
var enums = require('core/action/enums');
var EventEmitter = require('core/event_emitter/public_event_emitter');

var SHOW_EVENT = 'showWidget';
var HIDE_EVENT = 'hideWidget';

/**
 * @constructor
 *
 * @param {Change} change
 * @param {ChangeConfig} config
 */
function WidgetChange(change:Change, config:ChangeConfig) {
  // Widget handler expects this to be mutable; make a shallow copy
  this.change = _.extend({}, change);
  this.identifier = config.identifier;
}

/**
 * Apply the change.
 */
WidgetChange.prototype.apply = function () {
  EventEmitter.emit({
    type: SHOW_EVENT,
    name: this.change.widget_id,
    data: this.change,
  });
  // TODO(jordan) pass a resolve function along with the event to allow
  // widget handler code to declare a widget is done applying/undoing
  return deferred().resolve(enums.changeState.APPLIED);
};

if (__UNDO_CHANGES_UPON_VIEW_DEACTIVATION__ || __TEST__) {
  /**
   * Undo action
   */
  WidgetChange.prototype.undo = function () {
    EventEmitter.emit({
      type: HIDE_EVENT,
      name: this.change.widget_id,
      data: this.change,
    });
    return deferred().resolve(enums.changeState.UNAPPLIED);
  };
}

/**
 * PluginManager registration method
 * @param {PluginManager} PluginManager
 */
module.exports = function(PluginManager:PluginManagerClass) {
  PluginManager.registerChangeApplier(enums.changeType.WIDGET, WidgetChange);
};


if (__TEST__) {
  module.exports.plugin = WidgetChange;
}
